import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'sprite-vault:user-pins:v1';

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function useUserPins() {
  const [pins, setPins] = useState(load);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(pins));
    } catch { /* ignore */ }
  }, [pins]);

  const addPin = useCallback((pos, label, note) => {
    const item = {
      id: `pin-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      pos, // [y, x] in image-pixel CRS.Simple coords
      label: (label || 'Meet-up spot').trim().slice(0, 40),
      note: (note || '').trim().slice(0, 200),
      createdAt: new Date().toISOString(),
    };
    setPins((prev) => [...prev, item]);
    return item;
  }, []);

  const removePin = useCallback((id) => {
    setPins((prev) => prev.filter((p) => p.id !== id));
  }, []);

  const clearAll = useCallback(() => setPins([]), []);

  return { pins, addPin, removePin, clearAll };
}
